import { Injectable } from '@angular/core';
import { ProductionOrderListStore } from './production-order-list.store';
import { MachineScheduleViewModel, ProductionOrderStatus } from 'chronos-core-client';
import { ProductionOrderListQuery } from './production-order-list.query';

@Injectable({
  providedIn: 'root'
})
export class ProductionOrderListService {
  constructor(
    private productionOrderListStore: ProductionOrderListStore,
    private productionOrderListQuery: ProductionOrderListQuery
) {}

  public setLoading(loading: boolean): void {
    this.productionOrderListStore.setLoading(loading);
  }

  public resetProductionOrdersStore(): void {
    this.productionOrderListStore.setLoading(true);
    this.productionOrderListStore.reset();
    this.productionOrderListStore.setLoading(false);
  }

  public endProductionOrder(productionOrderId: number): void {
    this.productionOrderListStore.setLoading(true);
    this.productionOrderListStore.remove(productionOrderId);
    this.productionOrderListStore.setLoading(false);
  }

  public reopenProductionOrder(id: number): void {
    this.productionOrderListStore.setLoading(true);
    this.productionOrderListStore.update(id, { status: ProductionOrderStatus.Reopened, isNextProductionOrder: false });
    this.productionOrderListStore.setLoading(false);
  }

  public setProductionOrders(productionOrders: MachineScheduleViewModel[]): void {
    this.productionOrderListStore.set(productionOrders);
    this.productionOrderListStore.setLoading(false);
    this.productionOrderListStore.setHasData(true); // this method is called either on first load or on clear, so we need to load the next batch to know if there are more orders to load or not
  }

  public appendProductionOrders(productionOrders: MachineScheduleViewModel[]): void {
    if (productionOrders.length === 0) {
      this.productionOrderListStore.setHasData(false);
      this.productionOrderListStore.setLoading(false);
      return;
    }

    const existingProductionOrders = this.productionOrderListQuery.getAll();
    this.productionOrderListStore.set([...existingProductionOrders, ...productionOrders]);
    this.productionOrderListStore.setLoading(false);
  }

  public setCheckedProductionOrder(id: number): void {
    this.productionOrderListStore.update(id, { status: ProductionOrderStatus.Checked });
  }

  public setUncheckedProductionOrder(id: number, wasReopened: boolean): void {
    if (wasReopened) {
      this.productionOrderListStore.update(id, { status: ProductionOrderStatus.Reopened });
    } else {
      this.productionOrderListStore.update(id, { status: ProductionOrderStatus.Open });
    }
  }
}
